let config = {
    title: '주술회전: 어둠의 부상',
    email: 'support@jujutsudarkascensionkr.com',
    policy: 'https://jujutsudarkascensionkr.com/privacy_policy.html',
    term: 'https://jujutsudarkascensionkr.com/terms.html', 
    copyright: '© 2024 Guangzhou Mika Network Technology Co., Ltd',
    introduceTitle: [
       '《주술회전: 어둠의 부상》에서 당신은 흥미진진한 주술의 여정을 시작하게 됩니다. 주술사로서 당신은 다른 강력한 주술사들과 협력하여 악의 주령의 침략을 막고 인류를 보호해야 합니다. 게임은 치열한 전투와 흥미진진한 스토리라인으로 가득 차 있어, 당신을 환상적인 주술의 세계에 몰입하게 합니다.'
    ],
    introduceText: [
        {
            title: '**^^^깊이 있는 스토리^^^**',
            text: [
                '원작 스토리를 경험하며 주술 세계의 신비를 밝혀내세요. 악의 주령을 찾아 제거하는 임무부터 숨겨진 음모를 밝혀내는 것까지, 모든 결정이 당신의 운명에 영향을 미칩니다.'
            ]
        },
        {
            title: '**^^^다양한 전투^^^**',
            text: [
                '고속 전투에 참여하고 다양한 주술 기술을 활용하여 적을 물리치세요. 게임에는 솔로 도전, 팀 협력, 경쟁 전투 등 여러 전투 모드가 포함되어 있으며, 이를 통해 전투 기술을 최대한으로 발휘할 수 있습니다.'
            ]
        },
        {
            title: '**^^^자유 탐험^^^**',
            text: [
                '주술 세계의 다양한 지역을 탐험하며 신비한 장소를 발견하고 숨겨진 보물을 찾아보세요. 각 지역은 풍부한 탐험 콘텐츠를 제공하며, 이를 발견하고 잠금 해제하는 것이 기다리고 있습니다.'
            ]
        },
        {
            title: '**^^^캐릭터 수집^^^**',
            text: [
                '다양한 주술사를 수집하여 가장 강력한 전투 팀을 구성하세요. 각 캐릭터는 독특한 주술 기술과 속성을 보유하고 있습니다. 이들을 조합하여 무적의 전투 라인업을 만드세요.'
            ]
        },
        {
            title: '**^^^멀티플레이어 전투^^^**',
            text: [
                '다른 플레이어와 협력하여 치열한 전투에 참여하고 주술 세계에서 패권을 쟁취하세요! 동맹을 맺고 적을 물리쳐 주술 세계의 전설적인 영웅이 되어보세요!'
            ]
        },
        {
            title: '**^^^3D 아트 경험^^^**',
            text: [
                '독특한 3D 기술로 놀라운 시각적 효과를 창조합니다. 캐릭터 전시부터 전투 장면까지, 모든 특수 효과가 세심하게 제작되었습니다.'
            ]
        },
    ]
}
export default config;